<template>
  <div class="w-full grid gap-1 content-start">
    <label v-if="labelText">{{ labelText }}</label>
    <v-autocomplete
      class="focus-within:!border-primary-main border-2 items-center focus-within:outline outline-2 duration-200 bg-white p-3 pt-0 pl-0 pr-0 pb-0 outline-primary-main/20 tl-input min-h-[56px]"
      :class="classObject"
      @update:modelValue="emitSelected"
      :modelValue="items[modelValue - 1]?.title"
      variant="plain"
      :hide-details="true"
      :density="size === 'small' ? 'compact' : 'compact'"
      :items="items"
      :placeholder="placeholder"
    ></v-autocomplete>
  </div>
</template>

<script lang="ts">
import type Vue from 'vue';
import { VSelect } from 'vuetify/components';

export default {
  extends: VSelect,
  props: {
    modelValue: { type: [String, Number], default: '' },
    labelText: { type: String, required: false },
    size: { type: String, default: 'medium' },
    items: { type: Array, required: true },
    placeholder: { type: String, required: false, default: 'Select Item' }
  },
  data() {
    return {
      selectedValue: this.modelValue
    };
  },
  computed: {
    classObject() {
      return {
        'rounded-2xl !text-xs': this.size === 'small',
        'rounded-lg': this.size === 'medium'
      };
    }
  },
  methods: {
    emitSelected(newValue: any) {
      this.$emit('update:modelValue', newValue);
    },
  }
} as Vue.ComponentOptions<any>;
</script>
<style>
.v-list-item .v-list-item__content .v-list-item-title {
  width: 400px;
  white-space: pre-wrap;
  word-break: break-word;
}

.v-autocomplete__selection-text {
  margin-left: 15px;
  margin-bottom: 10px;
}

</style>